module.exports = __webpack_public_path__ + "images/erp-nation-glad-title.1792033684119.png";